import React from 'react';
import PropTypes from 'prop-types';
import { SelectableBlock } from '../../../Elements';
import { Label } from 'semantic-ui-react';
import currencyFormatter from 'currency-formatter';
import paymentsHelper from '../../../../lib/utils/payments';
import moment from 'moment-timezone';
import styles from '../Invoice.scss';

const SelectPayment = ({
  onPaymentSelect,
  payments,
  selectedPayment,
  timeZone = moment.tz.guess()
}) =>
  <div>
    <h4>Select a payment to issue a partial or full refund</h4>
    {payments.map(({ node: payment }) => {
      const cannotRefundSquare =
        // eslint-disable-next-line no-underscore-dangle
        payment.__typename === 'SquarePayment' &&
        moment(payment.paid_at).isBefore(moment().subtract(1, 'years'));
      return (
        <div key={payment.id} style={{ margin: '2em 0' }}>
          <SelectableBlock
            name='payment'
            value={payment}
            radio
            onChange={onPaymentSelect}
            checked={selectedPayment && selectedPayment.id === payment.id}
            disabled={
              cannotRefundSquare ||
              paymentsHelper.refundedCents(payment) === payment.amount_cents
            }
          >
            <div style={{ display: 'flex' }}>
              <div style={{ flex: 1 }}>
                <h4 style={{ marginBottom: '0.5em' }}>
                  Paid by {payment.name}
                </h4>
                <div
                  className={styles.paymentAmountDescription}
                  style={{ marginBottom: '0.5em' }}
                  title={`${moment
                    .tz(payment.paid_at, timeZone)
                    .format('MMM D, YYYY [at] LT')} ${moment
                    .tz(timeZone)
                    .format('z')}`}
                >
                  {moment.tz(payment.paid_at, timeZone).format('L')}
                </div>
                {cannotRefundSquare &&
                  <div
                    className={styles.warning}
                    style={{ marginBottom: '0.5em' }}
                  >
                    *Must refund card payments within 1 year of original transaction
                  </div>}
                {payment.notes &&
                  <p className={styles.paymentAmountDescription}>
                    <em>
                      Notes: {payment.notes}
                    </em>
                  </p>}
              </div>
              <div style={{ textAlign: 'right' }}>
                <h4 style={{ marginBottom: '0.5em' }}>
                  {currencyFormatter.format(payment.amount_cents / 100, {
                    code: payment.amount_currency
                  })}
                </h4>
                {paymentsHelper.refundedCents(payment) > 0 &&
                  <p className={styles.paymentAmountDescription}>
                    ({currencyFormatter.format(
                      paymentsHelper.refundedCents(payment) / 100,
                      {
                        code: payment.amount_currency
                      }
                    )}{' '}
                    Refunded)
                  </p>}
                <div className={styles.paymentAmountDescription}>
                  <Label
                    size='small'
                    content={paymentsHelper.payments(payment)}
                  />
                </div>
              </div>
            </div>
          </SelectableBlock>
        </div>
      );
    })}
  </div>;

SelectPayment.propTypes = {
  onPaymentSelect: PropTypes.func.isRequired,
  payments: PropTypes.array.isRequired,
  selectedPayment: PropTypes.object,
  timeZone: PropTypes.string
};

export default SelectPayment;



// WEBPACK FOOTER //
// ./webpack/components/Document/Invoice/Refund/SelectPayment.js